import * as React from 'react';

const Envelope16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm13.44-.5H2.56l4.556 3.555a1.25 1.25 0 0 0 1.768 0zM1.5 4.56V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4.56L9.945 8.117a2.75 2.75 0 0 1-3.89 0L1.5 4.561Z"
  }
));
Envelope16.Size = 16;
Envelope16.Title = "Envelope";

export { Envelope16 as default };
